"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.tooltip.view': '查看入职详情',
    'onboarding.tooltip.edit': '编辑入职条目',
    'onboarding.tooltip.delete': '删除入职条目',
};
